import { ArrowDownRight, ArrowUpRight, ChevronRight } from "lucide-react";
import { STATUS, delta, fmt } from "@/lib/format";
import { StatusBadge } from "@/components/StatusBadge";

function Delta({ kpi, prevYear, short }) {
  const d = delta(kpi.value, kpi.prev);
  if (d === null) return short ? null : <span className="text-xs text-muted-foreground">Tidak ada pembanding {prevYear}</span>;
  const up = d >= 0;
  const good = kpi.inverse ? !up : up;
  const Icon = up ? ArrowUpRight : ArrowDownRight;
  return (
    <span className={`inline-flex flex-wrap items-center gap-x-1 text-xs font-medium ${good ? "text-emerald-600 dark:text-emerald-400" : "text-rose-600 dark:text-rose-400"}`}>
      <Icon className="h-3.5 w-3.5" />
      <span className="font-num">{(Math.abs(d) * 100).toFixed(1).replace(".", ",")}%</span>
      {!short && <span className="whitespace-nowrap text-muted-foreground font-normal">vs {prevYear}</span>}
    </span>
  );
}

export const KpiCard = ({ kpi, prevYear, onClick, index = 0 }) => {
  const bar = STATUS[kpi.status]?.bar || "bg-slate-300 dark:bg-slate-600";
  return (
    <button
      type="button"
      data-testid={`kpi-card-${kpi.key}`}
      onClick={onClick}
      disabled={!onClick}
      style={{ animationDelay: `${index * 50}ms` }}
      className="rise group relative overflow-hidden rounded-xl border bg-card p-4 sm:p-5 text-left shadow-sm transition-shadow duration-200 hover:shadow-md disabled:cursor-default"
    >
      <span className={`absolute left-0 top-0 h-full w-1 ${bar}`} />
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{kpi.label}</p>
        {kpi.status && <StatusBadge status={kpi.status} />}
      </div>
      <p data-testid={`kpi-value-${kpi.key}`} className="font-num mt-3 text-2xl sm:text-[1.7rem] font-bold tracking-tight">
        {fmt(kpi.value, kpi.fmt)}
      </p>
      <div className="mt-2 flex items-center justify-between gap-2">
        {kpi.prev !== null && kpi.prev !== undefined ? <Delta kpi={kpi} prevYear={prevYear} /> : <span className="text-xs text-muted-foreground">{kpi.hint || ""}</span>}
        {onClick && <ChevronRight className="h-4 w-4 text-muted-foreground transition-transform group-hover:translate-x-0.5" />}
      </div>
      {kpi.hint && kpi.prev !== null && kpi.prev !== undefined && <p className="mt-1 text-[11px] text-muted-foreground">{kpi.hint}</p>}
      {kpi.parts && (
        <div data-testid={`kpi-parts-${kpi.key}`} className="mt-3 grid grid-cols-2 gap-2 border-t pt-2">
          {kpi.parts.map((p) => (
            <div key={p.label}>
              <p className="text-[10px] uppercase tracking-wider text-muted-foreground">{p.label}</p>
              <div className="flex flex-wrap items-baseline gap-x-2">
                <p data-testid={`kpi-part-${kpi.key}-${p.label.toLowerCase().replace(/\s+/g, "-")}`} className="font-num text-base font-semibold">{fmt(p.value, kpi.fmt)}</p>
                {p.prev != null && <Delta kpi={{ ...p, inverse: kpi.inverse }} prevYear={prevYear} short />}
              </div>
            </div>
          ))}
        </div>
      )}
    </button>
  );
};
